exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2uIUS0J6WT1JXrbCVKyL0r{font-weight:600;font-size:12px;height:16px}html[dir=ltr] ._2uIUS0J6WT1JXrbCVKyL0r{float:right}html[dir=rtl] ._2uIUS0J6WT1JXrbCVKyL0r{float:left}._35dykMJ1Ggx6skz6eNxt_h{font-size:9px}html[dir=ltr] ._35dykMJ1Ggx6skz6eNxt_h{margin-left:3px}html[dir=rtl] ._35dykMJ1Ggx6skz6eNxt_h{margin-right:3px}", ""]);
// Exports
exports.locals = {
	"seeMoreButton": "_2uIUS0J6WT1JXrbCVKyL0r",
	"downChevron": "_35dykMJ1Ggx6skz6eNxt_h"
};